import FormWizard1Container from "../../../../components/formsAndTable/forms/formLayout/formWizard1";

const FormWizard1 = () => {
  return <FormWizard1Container />;
};

export default FormWizard1;
